function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6373 0H3.36461C1.5062 0 0.000976562 1.50523 0.000976562 3.36364V33.6364C0.000976562 35.4948 1.5062 37 3.36461 37H20.1828V21.8636H15.1373V16.8182H20.1828V14.1088C20.1828 8.97923 22.682 6.72727 26.9454 6.72727C28.9871 6.72727 30.0668 6.87864 30.5781 6.94759V11.7727H27.6702C25.8606 11.7727 25.2282 12.728 25.2282 14.6621V16.8182H30.5327L29.8129 21.8636H25.2282V37H33.6373C35.4957 37 37.001 35.4948 37.001 33.6364V3.36364C37.001 1.50523 35.4941 0 33.6373 0Z",
  fill: "#B0DAC7"
});

function SvgProductionFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionFacebook);
export default __webpack_public_path__ + "static/media/Production_facebook.48b2c842.svg";
export { ForwardRef as ReactComponent };